import React from "react";

const CrossWhiteBlackIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_12_19)">
        <rect
          width="24"
          height="24"
          rx="12"
          fill="#121C27"
          fill-opacity="0.8"
        />
        <mask
          id="mask0_12_19"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="4"
          y="4"
          width="16"
          height="16"
        >
          <rect x="4" y="4" width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_12_19)">
          <path
            d="M12.0007 12.933L13.934 14.8663C14.0562 14.9886 14.2118 15.0497 14.4007 15.0497C14.5895 15.0497 14.7451 14.9886 14.8673 14.8663C14.9895 14.7441 15.0507 14.5886 15.0507 14.3997C15.0507 14.2108 14.9895 14.0552 14.8673 13.933L12.934 11.9997L14.8673 10.0663C14.9895 9.94412 15.0507 9.78856 15.0507 9.59967C15.0507 9.41079 14.9895 9.25523 14.8673 9.13301C14.7451 9.01079 14.5895 8.94967 14.4007 8.94967C14.2118 8.94967 14.0562 9.01079 13.934 9.13301L12.0007 11.0663L10.0673 9.13301C9.9451 9.01079 9.78954 8.94967 9.60065 8.94967C9.41176 8.94967 9.25621 9.01079 9.13398 9.13301C9.01176 9.25523 8.95065 9.41079 8.95065 9.59967C8.95065 9.78856 9.01176 9.94412 9.13398 10.0663L11.0673 11.9997L9.13398 13.933C9.01176 14.0552 8.95065 14.2108 8.95065 14.3997C8.95065 14.5886 9.01176 14.7441 9.13398 14.8663C9.25621 14.9886 9.41176 15.0497 9.60065 15.0497C9.78954 15.0497 9.9451 14.9886 10.0673 14.8663L12.0007 12.933ZM12.0007 18.6663C11.0784 18.6663 10.2118 18.4913 9.40065 18.1413C8.58954 17.7913 7.88398 17.3163 7.28398 16.7163C6.68398 16.1163 6.20898 15.4108 5.85898 14.5997C5.50898 13.7886 5.33398 12.9219 5.33398 11.9997C5.33398 11.0775 5.50898 10.2108 5.85898 9.39967C6.20898 8.58856 6.68398 7.88301 7.28398 7.28301C7.88398 6.68301 8.58954 6.20801 9.40065 5.85801C10.2118 5.50801 11.0784 5.33301 12.0007 5.33301C12.9229 5.33301 13.7895 5.50801 14.6007 5.85801C15.4118 6.20801 16.1173 6.68301 16.7173 7.28301C17.3173 7.88301 17.7923 8.58856 18.1423 9.39967C18.4923 10.2108 18.6673 11.0775 18.6673 11.9997C18.6673 12.9219 18.4923 13.7886 18.1423 14.5997C17.7923 15.4108 17.3173 16.1163 16.7173 16.7163C16.1173 17.3163 15.4118 17.7913 14.6007 18.1413C13.7895 18.4913 12.9229 18.6663 12.0007 18.6663Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_b_12_19"
          x="-4"
          y="-4"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_12_19"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_12_19"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default CrossWhiteBlackIcon;
